import React, { useRef } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { Formik, Form as FormikForm } from "formik";
import MDInput from "components/MDInput";
import MDBox from "components/MDBox";

import ModalHeaderTitle from "./Header";
import { createPromotionApi } from "services/api/dashboardApi";
import { Suggestion } from "types/Dashboard";

const initialValues = {
  title: "Enjoy a 10% discount every day from 3 PM to 4 PM!",
  body: ""
};
type Prop = {
  open: boolean;
  suggestion: Suggestion;
  handleClose: () => void;
  addPromotion: (promotionName: string) => void;
};
const PromotionModal: React.FC<Prop> = (props) => {
  const { open, handleClose, addPromotion, suggestion } = props;
  const accessToken = localStorage.getItem("stmpz-token") || "";
  const businessId = localStorage.getItem("stmpz-business-id") || "";
  const formikRef = useRef<any>(null);

  const handleOnClose = (_: {}, reason: "backdropClick" | "escapeKeyDown") => {
    if (reason === "backdropClick") {
      console.info("Backdrop is clicked");
    } else {
      handleClose();
    }
  };
  const onSubmit = async (values) => {
    try {
      await createPromotionApi(
        accessToken,
        businessId,
        values.title,
        values.body
      );
      handleClose();
    } catch (error) {
      alert(`Created Failed: ${error}`);
    }

    addPromotion(values.name);
  };

  return (
    <div>
      <Dialog
        onClose={handleOnClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={true}
        maxWidth={"md"}
        disableEscapeKeyDown={true}
        onBackdropClick={(event) => {
          event.stopPropagation();
          return false;
        }}
      >
        <ModalHeaderTitle id="customized-dialog-title" onClose={handleClose}>
          {`Add Promotion`}
        </ModalHeaderTitle>
        <DialogContent dividers>
          <Formik
            initialValues={!!suggestion ? suggestion : initialValues}
            onSubmit={onSubmit}
            innerRef={formikRef}
          >
            {({ values, errors, handleBlur, handleChange, setFieldValue }) => (
              <FormikForm>
                <MDBox width={"100%"} mr={5}>
                  <MDInput
                    type="text"
                    label="Promotion Title"
                    name="title"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.title}
                    fullWidth
                    error={!!errors.title}
                    helperText={errors.title}
                  />
                </MDBox>

                <MDBox width={"100%"} mr={5} mt={2}>
                  <MDInput
                    type="text"
                    label="Description"
                    name="body"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.body}
                    fullWidth
                    error={!!errors.body}
                    helperText={errors.body}
                  />
                </MDBox>
              </FormikForm>
            )}
          </Formik>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              //Trigger formik button as outside the form
              if (formikRef.current) {
                formikRef.current.handleSubmit();
              }
            }}
          >
            {"Add Promotion"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
export default PromotionModal;
